module.exports = __webpack_public_path__ + "img/sign-success.c7e0fa9a.svg";